import React from 'react';
import { string, node } from 'prop-types';
import useStyles from '../../hooks/useStyles';

TextLabel.propTypes = {
	className: string,
	children: node,
	htmlFor: string
};

export default function TextLabel({ className, children, htmlFor }) {
	const classes = useStyles(styles);
	return (
		<label css={classes.root} className={className} htmlFor={htmlFor}>
			{children}
		</label>
	);
}

const styles = ({ css }) => ({
	root: css`
		display: inline-block;
		margin-bottom: 8px;
		line-height: 16px;
		font-size: 12px;
		width: 100%;
	`
});
